module.exports = __webpack_public_path__ + "img/bg4.47e1901a.jpg";